import request from '../utils/request'

/**
 * 认证相关API
 */

// 用户登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 获取当前用户信息
export function getCurrentUser() {
  return request({
    url: '/auth/me',
    method: 'get'
  })
}

// 验证token有效性
export function verifyToken(data) {
  return request({
    url: '/auth/verify',
    method: 'post',
    data
  })
}

// 用户登出
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export default {
  login,
  getCurrentUser,
  verifyToken,
  logout
}
